import QuestionSetModel from '@opsbase/lib-data-model/models/QuestionSetModel';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import AppPage from '@opsbase/web-app/AppPage/AppPage';
import { DVLPage } from '@opsbase/web-dvl-page';
import React from 'react';
export function AdvancedOpQuestionsPage() {
    // NOTE: The following line is required ensure the model enters the registry
    new QuestionSetModel();
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { startExpanded: true, disableFieldSelection: true, disableGrouping: true, disableHeadings: true, disableCounts: true, disableCharts: true, viewId: DataType.QUESTIONSET, itemPage: Pages.QUESTION_SETS_EDIT, itemCreatePage: Pages.QUESTION_SETS_CREATE, itemDeletePage: Pages.QUESTION_SETS_DELETE, notFoundText: i18n.t('no-question-sets-found') })));
}
export default AdvancedOpQuestionsPage;
